<template>
  <v-container>
    <v-card>
      <v-card-title>
        Workout Schedules
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openDialog()">Add New</v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="this.filteredSchedules"
        item-key="seqNo"
        class="elevation-1"
        :items-per-page="itemsPerPage"
        :sort-by="['dayOfWeek']"
        :sort-desc="[false]"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="openDialog(item)">edit</v-icon>
          <v-icon small @click="confirmDelete(item.seqNo)">delete</v-icon>
        </template>
        <template v-slot:item.swimmerCount="{ item }">
          {{ getSwimmerCount(item.dayOfWeek) }}
        </template>
      </v-data-table>
    </v-card>

    <!-- Add/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title
          >{{ form.seqNo ? "Edit" : "Add" }} Workout Schedule</v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="form.groupId"
                  label="Group ID"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.termId" label="Term ID" required />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.facilityId"
                  label="Facility ID"
                  required
                />
              </v-col>
              <v-col cols="6">
                <catValueDropDown
                  :outlined="true"
                  :catName="'WEEKDAYS'"
                  v-model.trim="form.dayOfWeek"
                  label="Day of Week"
                />
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="startTimeMenu"
                  v-model="startTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.startTime"
                      label="Start Time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="form.startTime"
                    @change="startTimeMenu = false"
                    format="24hr"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <v-menu
                  ref="endTimeMenu"
                  v-model="endTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.endTime"
                      label="End Time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="form.endTime"
                    @change="endTimeMenu = false"
                    format="24hr"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <catValueDropDown
                  :outlined="true"
                  :catName="'FACILITY'"
                  v-model.trim="form.workoutType"
                  label="Workout Type"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="form.notes" label="Notes" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-1" text @click="saveSchedule">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
import { mapGetters, mapActions } from "vuex";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";

export default {
  components: {
    catValueDropDown,
  },
  props: {
    termId: {
      type: Number,
      required: false,
    },
    groupId: {
      type: Number,
      required: false,
    },
    facilityId: {
      type: Number,
      required: false,
    },
    swimmerCount: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
      startTimeMenu: false,
      endTimeMenu: false,
      itemsPerPage: 50,
      headers: [
       //  { text: "Group", value: "groupId" },
       //  { text: "Term", value: "termId" },
       //  { text: "Facility", value: "facilityId" },
        { text: "Day", value: "dayOfWeek" },
        { text: "Start", value: "startTime" },
        { text: "End", value: "endTime" },
        { text: "Active Swimmers", value: "swimmerCount" },
        { text: "Type", value: "workoutType" },
        { text: "Notes", value: "notes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      // days: [
      //   "Monday",
      //   "Tuesday",
      //   "Wednesday",
      //   "Thursday",
      //   "Friday",
      //   "Saturday",
      //   "Sunday",
      // ],
      workoutType: ["pool", "dryland", "virtual", "other"],
    };
  },
  computed: {
    ...mapGetters(["workoutSchedules", "user"]),
    filteredSchedules() {
      return this.workoutSchedules.filter((s) => {
        const matchesTerm = this.termId ? s.termId === this.termId : true;
        const matchesGroup = this.groupId ? s.groupId === this.groupId : true;
        const matchesFacility = this.facilityId
          ? s.facilityId === this.facilityId
          : true;
        return matchesTerm && matchesGroup && matchesFacility;
      });
    },
  },
  created() {
    this.allWorkoutSchedules();
  },
  methods: {
    ...mapActions([
      "allWorkoutSchedules",
      "workoutScheduleMerge",
      "workoutScheduleDelete",
    ]),
    getSwimmerCount(day) {
      return this.swimmerCount && this.swimmerCount[day]
        ? this.swimmerCount[day]
        : 0;
    },

    openDialog(item = {}) {
      this.form = {
        ...item,
        groupId: item.groupId ? item.groupId : this.groupId,
        facilityId: item.facilityId ? item.facilityId : this.facilityId,
        termId: item.termId ? item.termId : this.termId,
      }; // Copy for editing
      this.dialog = true;
    },

    saveSchedule() {
      this.form.updateSource = this.user.userName;
      this.workoutScheduleMerge(this.form).then(() => {
        this.dialog = false;
      });
    },

    confirmDelete(seqNo) {
      if (confirm("Are you sure you want to delete this workout schedule?")) {
        this.workoutScheduleDelete({ seqNo });
      }
    },
  },
};
</script>
  